import styled from 'styled-components';

export const InputContainer = styled.div<{
  width?: string | number;
  disabled?: boolean;
  error?: boolean;
}>`
  position: relative;
  display: inline-block;
  width: ${(props) => props.width || 'auto'};
  input {
    background: ${({ theme, disabled }) => (disabled ? theme.color.Gray20 : theme.color.White)};
    border: 1px solid
      ${({ theme, disabled, error }) => (error ? 'red' : disabled ? theme.color.Gray20 : theme.color.Gray20)};
    color: ${({ theme, disabled }) => (disabled ? theme.color.Gray40 : theme.color.Black)};
    height: 45px;
    font-size: 16px;
    line-height: 45px;
    padding: 0 16px;
    box-sizing: border-box;

    @media (max-width: 1279px) {
      border-radius: 12px;
      font-size: 14px;
    }
  }
  input ::placeholder {
    font-size: 16px;
    color: ${({ theme }) => theme.color.Gray30};
    font-weight: 500;
    letter-spacing: -2.2%;
    line-height: 45px;

    @media (max-width: 1279px) {
      font-size: 14px;
    }
  }
  p {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    margin: 0;
  }
`;
